export default __webpack_public_path__ + "static/media/new-logo-menu.e26e0c5b.png";